import Index from "./index.jsx"

export default Index